import { createFileRoute, Link } from '@tanstack/react-router'
import { Header } from '@/components/layout/header'
import { Main } from '@/components/layout/main'
import { ProfileDropdown } from '@/components/profile-dropdown'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import { Lock } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/sem-permissao/')({
  component: SemPermissao,
})

function SemPermissao() {
  return (
    <>
      <Header fixed>
        <div className='ms-auto flex items-center space-x-4'>
          <ProfileDropdown />
        </div>
      </Header>
      <Main className='flex flex-1 items-center justify-center'>
        <Card className='p-8 max-w-md text-center space-y-4'>
          <Lock className='w-12 h-12 text-muted-foreground mx-auto' />
          <h2 className='text-xl font-bold'>Sem permissão</h2>
          <p className='text-muted-foreground'>
            Você não tem permissão para acessar esta página. Fale com o administrador da sua empresa.
          </p>
          <Button asChild variant='outline'>
            <Link to='/novo-documento'>Voltar</Link>
          </Button>
        </Card>
      </Main>
    </>
  )
}
